<div class="gif-container">
    <img [src]="currentFrame" alt="Animated GIF" />
</div>

<div [@scaleUp]="animationState" class="goal">
    Obiettivo Raggiunto!
</div>
<button (click)="Animation()">Mostra Animazione</button>
